import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-logout',
    templateUrl: './Interstitial.component.html'
})
export class InterstitialComponent implements OnInit {

    isAuthenticated = false;

    constructor() {
    }

    ngOnInit() {

    }
}